import _ from 'lodash';
import api from './api';
import { ActionPlanSnapshot, PlanSnapshot } from '../models';
import { getWorkspaceAliasFromUrl } from '../lib/workspace';
import { errors } from '.';
import { getBackVersion } from '../config';

type BackPaidPlan = {
    maxPrice?: BasePlanResponse;
    minPrice: BasePlanResponse;
};

type BackPlans = {
    freeTrial: BasePlanResponse[];
    paid?: {
        boleto: BackPaidPlan[];
        creditCard: BackPaidPlan[];
        pix: BackPaidPlan[];
    };
};

type BasePlanResponse = Omit<PlanSnapshot, 'planActions' | 'maxPrice'> & {
    planActions: ActionPlanSnapshot[];
};

type PlanResponse = BasePlanResponse & {
    maxPrice?: BasePlanResponse;
};

const fromPaidToPlan = (paid: BackPaidPlan): PlanResponse => ({
    ...paid.minPrice,
    maxPrice: paid.maxPrice,
});

const convertPlans = (backPlan: BackPlans): PlanResponse[] => {
    const freeTrial = backPlan.freeTrial as PlanResponse[];
    if (backPlan.paid) {
        const boleto = backPlan.paid.boleto.map(fromPaidToPlan);
        const creditCard = backPlan.paid.creditCard.map(fromPaidToPlan);
        const flatResults = [...freeTrial, ...boleto, ...creditCard];
        // This sort makes the plans show up ordered by the less expensive
        // maxPrice plans. Since the plans are flattened, the maxPrice prop
        // represents the discount. If we order the plans by discount on
        // ascending order, we guarantee that the best discount is always the
        // last on the list, and therefore always reflected on the store.
        return _.sortBy(flatResults, x =>
            x.maxPrice ? x.maxPrice.price / x.maxPrice.duration : -1
        );
    }
    return freeTrial;
};

const getAvailablePlans = (): Promise<PlanResponse[]> => {
    if (!getWorkspaceAliasFromUrl())
        return Promise.reject(errors.WorkspaceNotFound);
    return api
        .request<BackPlans>({
            method: 'GET',
            url: `${getBackVersion()}/account/plans`,
        })
        .then(convertPlans);
};

const getPlanById = (planId: number): Promise<PlanResponse | undefined> => {
    if (!getWorkspaceAliasFromUrl())
        return Promise.reject(errors.WorkspaceNotFound);
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/account/plans/` + planId.toString(),
    });
};

export default { getAvailablePlans, getPlanById };
export type { PlanResponse };
